import ReporteStockShow from './ReporteStockShow'
export {ReporteStockShow}
export default ReporteStockShow
